import { createGlobalStyle } from "styled-components";
import { theme } from "./styles";

export const GlobalStyles = createGlobalStyle`
  .emergency-services-theme{
    & .swal-title {
      font-weight: 100;
      font-family: 'basic-sans', serif;
      color: ${theme.palette?.text?.primary || `black`}; 
    }
    & .swal-text {
      font-weight: 100;
      font-family: 'basic-sans', serif;
        color: ${theme.palette?.text?.primary || `black`};
    }
   & .swal-icon--success:after, .swal-icon--success:before {
     background: transparent;
   }
   & .swal-icon--success__hide-corners{
    background: transparent; 
   }
    & button {
      background-color: ${theme.palette.secondary.main};
      color: ${theme.palette?.getContrastText?.(theme.palette.secondary.main) || `white`};
    }
  }

  * {
    text-rendering: optimizeLegibility!important;
    -webkit-font-smoothing: antialiased!important;
  }
  /*
 * The Typekit service used to deliver this font or fonts for use on websites
 * is provided by Adobe and is subject to these Terms of Use
 * http://www.adobe.com/products/eulas/tou_typekit. For font license
 * information, see the list below.
 *
 * basic-sans:
 *   - http://typekit.com/eulas/00000000000000003b9b0439
 *   - http://typekit.com/eulas/00000000000000003b9b043a
 *   - http://typekit.com/eulas/00000000000000003b9b043d
 *   - http://typekit.com/eulas/00000000000000003b9b043e
 *
 * © 2009-2020 Adobe Systems Incorporated. All Rights Reserved.
 */
/*{"last_published":"2020-07-21 07:02:18 UTC"}*/

@font-face {
font-family:"basic-sans";
src:url("https://use.typekit.net/af/bedfa2/00000000000000003b9b0439/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/bedfa2/00000000000000003b9b0439/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/bedfa2/00000000000000003b9b0439/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;
}

@font-face {
font-family:"basic-sans";
src:url("https://use.typekit.net/af/5c6dd4/00000000000000003b9b043a/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/5c6dd4/00000000000000003b9b043a/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/5c6dd4/00000000000000003b9b043a/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;
}

@font-face {
font-family:"basic-sans";
src:url("https://use.typekit.net/af/1a9b5f/00000000000000003b9b043d/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/1a9b5f/00000000000000003b9b043d/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/1a9b5f/00000000000000003b9b043d/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:400;
}

@font-face {
font-family:"basic-sans";
src:url("https://use.typekit.net/af/cc97f2/00000000000000003b9b043e/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/cc97f2/00000000000000003b9b043e/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/cc97f2/00000000000000003b9b043e/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;
}

.tk-basic-sans { font-family: "basic-sans",sans-serif; }
`;
